import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getSettings() {
        return useApiClient().get('/crms/mailbox-settings');
    },
    saveSettings(data: object) {
        return useApiClient().post('/crms/mailbox-settings', data);
    },
    testConnection(data: object) {
        return useApiClient().post('/crms/mailbox-settings/test-connection', data);
    },
};
